import React, { FunctionComponent } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all_with_count } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

// import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Divider,
  Grid,
  Paper,
} from '@mui/material';

import {
  Dt,
  Typography
} from '../../../../components/v2/styled';

import { User } from '../../../../models/User';
import { Workshop } from '../../../../models/Workshop';

// const { DateTime } = require("luxon");

import HelpersPractice from '../../../../actions/helpers/practice';
import HelpersClientWidgets from '../../../../actions/helpers/client_widgets';

type Props = {
  object: User;
}

// Shape of HelpersClientWidgets.getWorkshopsRows rows (untyped JS helper,
// local annotation keeps the map callback typed).
type WorkshopRow = {
  id?: number;
  subject: string;
  startTime: string;
  subscribedCount: number;
  backupsCount: number;
}

export const CoachUserWidgetsWorkshops: FunctionComponent<Props> = ({
  object
}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let is_nutri_workshop = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'nutri_workshop'});

  const {
    data: workshops,
    isSuccess,
  } = useQuery({
    queryKey: ["workshops_widget", (login?.practice_id || currentPractice?.id)],
    queryFn: () =>
      fetch_all_with_count<Workshop>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'workshop',
          fields: ['id', 'subject', 'start_time', 'is_cancelled', 'get_subscriber_ids', 'get_backup_ids'],
          page: 0,
          per_page: 5,
          order: 'start_time ASC',
          filter: {
            advanced: {
              practice_id: (login?.practice_id || currentPractice?.id)
            }
          }
        },
        login
      ),
    select: (d) => d.result,
    enabled: !!(login?.practice_id || currentPractice?.id) && !!is_nutri_workshop,
  });

  if (!is_nutri_workshop) return null;

  const rows: WorkshopRow[] = HelpersClientWidgets.getWorkshopsRows(workshops || []);

  return <Paper sx={{padding: 2, marginTop: 1}}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5" html>{t("coach.submenu.detail.workshops")}</Typography>
        <Divider />
      </Grid>

      {isSuccess && rows.length === 0 && <Grid item xs={12}>
        <Typography variant="body2" sx={{fontStyle: 'italic'}} html>{t("shared.terms.no_results")}</Typography>
      </Grid>}

      {/* Workshop rows: subject + start datetime, subscribed/backups counts
          below, a Divider between consecutive rows. */}
      {rows.map((row, idx) => <React.Fragment key={row.id}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" noWrap>{row.subject || '-'}</Typography>
          <Typography variant="caption" sx={{color: 'text.secondary'}}>
            <Dt d={row.startTime} f="cccc DDD - t" />
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" html>
            {`${t("coach.submenu.detail.workshops_subscribed_count", {count: row.subscribedCount})} · ${t("coach.submenu.detail.workshops_backups_count", {count: row.backupsCount})}`}
          </Typography>
        </Grid>
        {idx < rows.length - 1 && <Grid item xs={12}>
          <Divider />
        </Grid>}
      </React.Fragment>)}
    </Grid>
  </Paper>;
}
